import Vue from 'vue';
import FloatingSupport from '~/components/_core/ui/floating-support/index.vue';
import HeaderDefault from '@/components/_core/ui/header';

export default Vue.extend({
  components: {
    FloatingSupport,
    HeaderDefault
  },
  data() {
    return {
      type         : 'authenticated',
      subscribe    : null,
      legacyLayout : !this.$store.state._core.application.layoutv2
    };
  },
  computed: {
    disableHeader() {
      return this.$route.query.disableHeader === 'true';
    }
  },
  beforeMount() {
    this.subscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === '_core/application/SET_LAYOUT_V2') {
        this.legacyLayout = !state._core.application.layoutv2;
      }
    });
  },
  beforeDestroy() {
    if (this.subscribe) {
      this.subscribe();
    }
  }
});
